import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useDashboardSearchCondition } from '@/providers/DashboardSearchConditionProvider';
import { useWorkspaceUsers } from '@/hooks/api/0150_workspace_users';
import { usePaymentContexts } from '@/hooks/api/0511_payment_contexts';
import { useMenuListedTeams } from '@/hooks/api/2260_menu_listed_teams';

export const SearchConditionTags = () => {
  const { _w_ } = useCurrentWorkspace();
  const { purchaseOrdersDashboardSearchCondition: searchCondition } = useDashboardSearchCondition();
  const { data: users } = useWorkspaceUsers({ identifier: _w_!.identifier });
  const { data: teams } = useMenuListedTeams({ identifier: _w_!.identifier });
  const { data: paymentContexts } = usePaymentContexts();
  const isConditionExist = Object.values(searchCondition)
    .flat()
    .some((v) => v);

  if (!isConditionExist) return <></>;

  return (
    <div className="d-flex mb-4 align-items-center flex-wrap">
      {teams &&
        teams.purchase_order_teams
          .filter((d) => searchCondition.team_ids.includes(d.id))
          .map((d) => (
            <span key={`pm-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.name}
            </span>
          ))}
      {paymentContexts &&
        paymentContexts
          .filter((d) => searchCondition.payment_context_ids.includes(d.id))
          .map((d) => (
            <span key={`phase-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.label}
            </span>
          ))}
      {users &&
        users
          .filter((d) => searchCondition.user_ids.includes(d.id))
          .map((d) => (
            <span key={`phase-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.user_account.name}
            </span>
          ))}
    </div>
  );
};
